import classNames from "classnames";
import { Tooltip } from "antd";
import { NaturalDimensions } from "types";
import { getCenterCropDimensions } from "helpers/utility/getCenterCropDimensions";
import styles from "./DefectAreaOverlay.module.scss";

interface PreviewCropCaptionProps {
  dimensions: NaturalDimensions;
  centerCropSize: number;
  roiSize: number;
}

const formatSize = (width: number, height: number) =>
  `${width.toLocaleString()} × ${height.toLocaleString()}`;

// Tells the user which part of the image the hover preview shows
const PreviewCropCaption = ({
  dimensions,
  centerCropSize,
  roiSize,
}: PreviewCropCaptionProps) => {
  const { naturalWidth, naturalHeight } = dimensions;
  if (naturalWidth <= 0 || naturalHeight <= 0) return null;

  const crop = getCenterCropDimensions(dimensions, centerCropSize);
  const isCropped =
    crop.naturalWidth < naturalWidth || crop.naturalHeight < naturalHeight;
  const cropSize = formatSize(crop.naturalWidth, crop.naturalHeight);
  const imageSize = formatSize(naturalWidth, naturalHeight);
  // Compact on purpose: the words live in the tooltip so the card title keeps its room
  const tooltip = (
    <>
      <div>
        {isCropped
          ? `Context: the center ${cropSize} px of the ${imageSize} px image.`
          : `Context: the full ${imageSize} px image.`}
      </div>
      {roiSize > 0 && (
        <div>
          Classification area: the pink marker, {formatSize(roiSize, roiSize)}{" "}
          px.
        </div>
      )}
    </>
  );

  return (
    <Tooltip title={tooltip} placement="bottomLeft">
      <div className={styles.cropCaption}>
        <span className={classNames(styles.swatch, styles.swatchMargin)} />
        <span>{isCropped ? cropSize : imageSize}</span>
        {isCropped && (
          <span className={styles.cropCaptionMuted}>of {imageSize}</span>
        )}
        {roiSize > 0 && (
          <>
            <span className={styles.cropCaptionDivider} />
            <span className={classNames(styles.swatch, styles.swatchRoi)} />
            <span>{roiSize.toLocaleString()} px</span>
          </>
        )}
      </div>
    </Tooltip>
  );
};

export default PreviewCropCaption;
